import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserLeague')
export class UserLeague {

  @JsonProperty('division_id', Number)
  divisionId: number = 0;

  @JsonProperty('division_tier', Number)
  divisionTier: number = 0;

  @JsonProperty('division_end_date_timestamp', Number)
  divisionEndDateTimestamp: number = 0;

  @JsonProperty('game', Number)
  game: number = 0;

  @JsonProperty('point', Number)
  point: number = 0;

  @JsonProperty('rank', Number)
  rank: number = 0;

  @JsonProperty('is_reward_granted', Boolean)
  isRewardGranted: boolean = false;
}
